module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legenda-icon"
  }, [_c('div', {
    staticClass: "legenda-icon-mapa"
  }, [(!_vm.possuiMapa) ? _c('div', {
    staticClass: "legenda-icon-polygon"
  }) : _vm._e(), (!_vm.possuiMapa) ? _c('div', {
    staticClass: "legenda-icon-disabled"
  }) : _vm._e(), (_vm.possuiMapa && !_vm.isMultiEstilos) ? [(_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-polygon",
    style: (_vm.styles)
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-point",
    style: (_vm.styles)
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-linestring",
    style: (_vm.styles)
  }) : _vm._e()] : _vm._e(), (_vm.possuiMapa && _vm.isMultiEstilos) ? _c('div', {
    staticClass: "legenda-icon-multi"
  }, [(_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e()]) : _vm._e()], 2), _c('div', {
    staticClass: "legenda-icon-marcador"
  }, [(!_vm.possuiMarcador) ? _c('div', {
    staticClass: "beautify-marker marker"
  }) : _vm._e(), (!_vm.possuiMarcador) ? _c('div', {
    staticClass: "legenda-icon-disabled"
  }) : _vm._e(), (_vm.possuiMarcador && !_vm.isMultiEstilos) ? _c('div', {
    staticClass: "beautify-marker marker",
    style: ({
      'background-color': _vm.estilo.marcador.cor
    })
  }) : _vm._e(), (_vm.possuiMarcador && _vm.isMultiEstilos) ? _c('div', {
    staticClass: "legenda-icon-multi"
  }, [_c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  }), _c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  }), _c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7609e9f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/camadas/IconeLegenda.vue
// module id = 485
// module chunks = 1